import { Observable } from 'rxjs';
import {
  StatGenerali,
  AndamentoMensile,
  AndamentiQueryParams,
  StatsPie,
  StatsFlussoMensile
} from '../../models/stats.model';
import { PaginatedResponse } from '../../models/cantieri.model';

export abstract class StatsPort {
  abstract getStats(year: number): Observable<StatGenerali>;
  abstract getYears(): Observable<number[]>;
  abstract getAndamentiMensili(params?: AndamentiQueryParams): Observable<PaginatedResponse<AndamentoMensile>>;
  abstract getPie(year: number): Observable<StatsPie>;
  abstract getFlussoMensile(year: number): Observable<StatsFlussoMensile[]>;
}
